import { render, staticRenderFns } from "./gasClampDownstream.vue?vue&type=template&id=5d458444&scoped=true"
import script from "./gasClampDownstream.vue?vue&type=script&lang=js"
export * from "./gasClampDownstream.vue?vue&type=script&lang=js"
import style0 from "./gasClampDownstream.vue?vue&type=style&index=0&id=5d458444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d458444",
  null
  
)

export default component.exports